<div class="tw-p-3 form-check">
  <input class="form-check-input" [checked]="showEligibleCars" (change)="onShowEligibleCars()" type="checkbox" id="eligiblity">
  <label class="form-check-label tw-cursor-pointer tw-text-grayMid" for="eligiblity">
    <b>Eligible cars</b>
  </label>
</div>
